import React from 'react';

function Header() {  
    return(
        <center>
            <h1>Calcula tu nota para el examen</h1>
        </center>
    )
}

export default Header;